const OPEN_TICKET_STATUSES = ["open", "pending"];

const getTicketAccess = (ticket, user) => {
  if (!ticket || !OPEN_TICKET_STATUSES.includes(ticket.status)) {
    return { canAccess: true };
  }

  const userId = Number(user?.id);
  const ticketUserId = ticket.userId == null ? null : Number(ticket.userId);
  const isAdmin = user?.profile === "admin" || localStorage.getItem("profile") === "admin";

  if (!isAdmin) {
    return {
      canAccess: ticketUserId === userId,
      reason: ticketUserId === userId ? null : "assignedToOtherUser",
    };
  }

  if (ticket.queueId == null) {
    return { canAccess: true };
  }

  const userQueueIds = (user?.queues || user?.Queues || user?.UserQueues || [])
    .map((item) => item?.id ?? item?.queueId ?? item?.Queues?.id)
    .filter((id) => id != null)
    .map(Number);

  return {
    canAccess: userQueueIds.includes(Number(ticket.queueId)),
    reason: userQueueIds.includes(Number(ticket.queueId)) ? null : "queueNotAssigned",
  };
};

export default getTicketAccess;
